module.exports = __webpack_public_path__ + "static/media/single-lookboard.4ee745bb.jpg";